export class BscRecord {
  adviser_name = ''
  rnf_number = ''
  review_year = undefined
  review_quarter = undefined
  bsc_grade = ''
  isau_reviewer = ''
  remuneration_type = ''
  date_completed = ''
  selected_representative = ''
  last_bsc_grade = ''
  last_bsc_grade_period = ''
  review_oid = ''
}
export class ClientsReviewed {
  _oid = ''
  bsc_user_quarter_oid = ''
  review_oid = ''
  client_name = ''
  case_supervisor = ''
  review_date = undefined
  policy_number = ''
  plan_reference = ''
  plan_issuance_date = undefined
  sample_rounds = ''
  cat_1_infraction_count = undefined
  cat_2_infraction_count = undefined
  admin_error_count = undefined
  case_supervisor_oid = ''
  policy_oid = ''
  infraction_details = ''
  admin_error_details = ''
  documents_review = '' // this will be JSON.parse into DocumentsReview
  client_survey = '' // this will be JSON.parse into ClientSurvey
  complaints = '' // this will be JSON.parse into Complaint
  is_hardcopy_sub = undefined
}
export class ClientPolicy {
  policy_name = ''
  policy_number = ''
  tagged_kyc = ''
  policy_url = ''
  client_oid = ''
}
export class DocumentsReview {
  kpi1_comments = ''
  kpi2_comments = ''
  kpi3_comments = ''
  kpi4_comments = ''
  understanding_needs_client_particulars = ''
  understanding_needs_financial_objectives = ''
  understanding_needs_risk_tolerance = ''
  understanding_needs_employment_status = ''
  understanding_needs_financial_situation = ''
  understanding_needs_regular_income = ''
  understanding_needs_financial_commitment = ''
  understanding_needs_investment_portfolio = ''
  understanding_needs_proportion_amount = ''
  understanding_needs_conduct_cka = ''
  understanding_needs_valid_reason = ''
  sustainability_assumptions_used = ''
  sustainability_risk_profiling = ''
  sustainability_basis_of_recommendation = ''
  sustainability_financial_objectives = ''
  sustainability_is_affordable = ''
  sustainability_aligned_investment_horizon = ''
  sustainability_match_risk_profile = ''
  sustainability_concentration_risk = ''
  sustainability_particular_needs = ''
  sustainability_client_callback = ''
  sustainability_callback_adequately_performed = ''
  disclosure_client_sign = ''
  disclosure_needs_analysis = ''
  disclosure_prospectus = ''
  disclosure_benefit_illustration = ''
  disclosure_nature_objective = ''
  disclosure_details_provider = ''
  disclosure_party_against = ''
  disclosure_intended_client_profile = ''
  disclosure_frequency_reports = ''
  disclosure_frequency_period_payment = ''
  disclosure_benefits_product = ''
  disclosure_risk_factors = ''
  disclosure_amount_frequency_payment = ''
  disclosure_procedures_withdrawal = ''
  disclosure_warnings_exclusions = ''
  disclosure_freelook_period = ''
  ethics_any_indications = ''
}
export class ClientSurvey {
  comprehensive_understand_financial_situation = ''
  comprehensive_felt_influenced = ''
  comprehensive_explain_influence = ''
  suitability_understand_explanation = ''
  disclosures_inform_aware = ''
  ethics_aspect_dissatisfied = ''
  suitability_dissatisfied_elaborate = ''
  kpi5_comments = ''
  kpi6_comments = ''
  kpi7_comments = ''
  kpi8_comments = ''
}
export class Complaint {
  complaint_title = ''
  complaint_score = ''
  complaint_comments = ''
}

export class Review {
  question = ''
  key? = ''
  colspan? = undefined
}
